import { render } from "./visit-details.vue?vue&type=template&id=0bf715f5&scoped=true&ts=true"
import script from "./visit-details.ts?vue&type=script&lang=ts&external"
export * from "./visit-details.ts?vue&type=script&lang=ts&external"

import "./visit-details.less?vue&type=style&index=0&id=0bf715f5&lang=less&scoped=true&external"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf715f5"]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator,QField});
